module.exports = __webpack_public_path__ + "img/skin.baf79cca.svg";